import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import { Box, IconButton, InputBase, useTheme } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import * as yup from "yup";
import { tokens } from "../theme";
import { Formik } from "formik";

const Searchbox = ({ handleSearch }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const initialValues = {
    searchKey: "",
  };

  const checkoutSchema = yup.object().shape({
    searchKey: yup.string().nullable(),
  });

  return (
    <Box
      display="flex"
      backgroundColor={colors.primary[400]}
      p={0.2}
      borderRadius={1}
    >
      <Formik
        onSubmit={handleSearch}
        initialValues={initialValues}
        validationSchema={checkoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit} style={{ display: "flex", padding: 2 }}>
            {values.searchKey.length > 0 && (
              <IconButton 
                onClick={() => {
                  setFieldValue("searchKey", "");
                  handleSearch({ searchKey: "" });
                }}
              >
                <ClearIcon />
              </IconButton>
            )}
            <InputBase
              sx={{ ml: 1, flex: 1, minWidth: "250px" }}
              placeholder="Search by name, email, phone, account, ID..."
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.searchKey}
              name="searchKey"
            />
            <IconButton type="submit">
              <SearchIcon />
            </IconButton>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default Searchbox;
